import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

const classes = {
  searchResults: 'search-results',
  shopHeader: 'shop-header',
  fixed: 'fixed'
};

const body = document.body;
const shopHeader = document.querySelector('.' + classes.shopHeader);
const searchResults = document.querySelector('.' + classes.searchResults);

export class MetaHeaderTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.shopHeader = document.querySelector('.' + classes.shopHeader);
    this.searchResults = document.querySelector('.' + classes.searchResults);
    this.init();
  }

  init() {
    this.addScrollHandlerSubscription();
    this.bindTriggeredListener();
  }

  addScrollHandlerSubscription() {
    dispatchEvent(window, events.ADD_SCROLL_SUBSCRIPTION, {
      selector: '.meta-header-trigger',
      eventName: events.SCROLL_HANDLER_TRIGGERED
    });
  }

  bindTriggeredListener() {
    this.element.addEventListener(events.SCROLL_HANDLER_TRIGGERED, (e) => {
      this.handleTriggered(e.detail.direction);
    });
  }

  handleTriggered(direction) {
    if (direction === 'down') {
      shopHeader.classList.add(classes.fixed);
      searchResults.classList.add(classes.fixed);
    } else {
      shopHeader.classList.remove(classes.fixed);
      if(!searchResults.classList.contains("index")) {
        searchResults.classList.remove(classes.fixed);
      }
    }
  }
}